import React, { useState } from 'react'
import Button, { TYPES } from '../Button/index'
import DetailPageV3Comments from './DetailPageV3Comments'

/**
 * @param {Object} props - The props
 * @param {String} props.title - The comments component title
 * @param {String} props.moreButtonLabel - The more comments button label
 * @param {Map} props.detailData - The detail data
 * @returns {JSX.Element} DetailPageV3CommentsView
 */

const DetailPageV3CommentsView = (props) => {
  const {
    title,
    detailData,
    moreButtonLabel,
    commentCount,
  } = props

  const [commentsMobileVisible, setCommentsMobileVisible] = useState(false)

  const commentsBlockClassName = [
    'detail-page-v3__comments-block',
    commentsMobileVisible ? 'detail-page-v3__comments-block--mobile-visible' : null,
  ].filter((cls) => !!cls).join(' ')

  return (
    <div className="detail-page-v3__comments-view">
      <div className="detail-page-v3__comments-top">
        <div className="detail-page-v3__comments-top-headline">
          <div className="detail-page-v3__comments-top-title">
            {title}
          </div>
          <Button
            className="detail-page-v3__more-info-button detail-page-v3__more-info-button--mobile"
            type={TYPES.LINK}
            onClick={() => setCommentsMobileVisible(true)}
          >
            {moreButtonLabel} ({commentCount || 0})
          </Button>
        </div>
      </div>
      <div className={commentsBlockClassName}>
        <DetailPageV3Comments
          title={title}
          detailData={detailData}
          onCloseClick={() => setCommentsMobileVisible(false)}
          showCount={true}
        />
      </div>
    </div>
  )
}

export default DetailPageV3CommentsView
